/* eslint-disable no-unused-vars */
export enum Role {
  ADMIN = "admin",
  USER = "user",
  NONE = "none",
}
